import { useOpenableElementIsOpen } from 'src/components/hooks/useOpenableElement';
import useOpenAwaiter from 'src/components/hooks/useOpenAwaiter';

import ProjectionModeDialog, {
  ProjectionModeDialogProps,
} from '@/components/organisms/projectionModeDialog/ProjectionModeDialog';
import ChatThemeProvider from '@/providers/ChatThemeProvider';

const ProjectionModeDialogEx = (
  props: Omit<ProjectionModeDialogProps, 'open'> & { isOpenKey: string }
) => {
  const isOpen = useOpenableElementIsOpen(props.isOpenKey);
  return (
    <ChatThemeProvider>
      <ProjectionModeDialog open={isOpen} {...props} />
    </ChatThemeProvider>
  );
};

const useProjectionModeDialog = () => {
  const openAwaiter = useOpenAwaiter<
    | {
        language: string[];
        firstItemIsAutoPlay: boolean;
      }
    | undefined
  >();
  return {
    open: (props: Omit<ProjectionModeDialogProps, 'open' | 'onClose'>) =>
      openAwaiter.open(
        <ProjectionModeDialogEx
          isOpenKey={openAwaiter.key}
          onClose={openAwaiter.close}
          {...props}
        />
      ),
  };
};
export default useProjectionModeDialog;
